import Vue from "vue";

Vue.filter("UTCToDate", value => moment(value).format("YYYY-MM-DD"));
